import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';

import React from 'react';

import {
  CreateOrEditSnippetCategoryModal,
  ManageCategoriesModal,
} from '../../../features/snippets/ui/components';

import { useSubscriptionLimits } from '../../../features/subscription/hooks';

import { EmptySnippetsPage } from './EmptySnippetsPage';

import { snippetsModel } from '../../../features/snippets';

import { SnippetsActions } from './SnippetsActions';
import { UpgradePlanFromSnippetsScreen } from './UpgradePlanFromSnippetsScreen';
import { SnippetsContent } from './SnippetsContent';

import { useSnippetsExists } from '../hooks';
import { useMobileRedirect } from '../../../shared/hooks/useMobileRedirect';

import { TeamOnlyAlert, useShareParams } from '../../../entities/share';

export const SnippetsPage: React.FC = () => {
  const dispatch = useDispatch();

  const { secondTeam } = useShareParams();

  useMobileRedirect();

  const { snippets: allowSnippets } = useSubscriptionLimits();

  const isCreateCategoryModalOpen = useSelector(
    snippetsModel.selectors.selectIsCreateCategoryModalOpen
  );

  return (
    <>
      <Helmet titleTemplate="Snippets - Distribute" />
      <CreateOrEditSnippetCategoryModal
        isOpen={isCreateCategoryModalOpen}
        onClose={() =>
          dispatch(snippetsModel.actions.setIsCreateCategoryModalOpen(false))
        }
      />
      <ManageCategoriesModal />
      {secondTeam ? (
        <TeamOnlyAlert
          text={
            <>
              The item you are looking for is available only to members of the
              <b>{secondTeam.name}</b> team. Please switch to that team first.
            </>
          }
        />
      ) : (
        <div className="sm:px-1 sm:pt-1 min-w-0 flex flex-col flex-1 gap-y-4">
          <div className="flex items-center justify-between gap-3">
            <h1 className="font-medium text-gray-900 text-display-sm font-display">
              Snippets
            </h1>
            {allowSnippets && <SnippetsActions />}
          </div>
          {allowSnippets ? (
            <SnippetsPageContent />
          ) : (
            <UpgradePlanFromSnippetsScreen />
          )}
        </div>
      )}
    </>
  );
};

const SnippetsPageContent = () => {
  const isExists = useSnippetsExists();

  return isExists ? <SnippetsContent /> : <EmptySnippetsPage />;
};
